import { Category, ErrorResponse, ServiceResponse } from '@bzbs/react-api-client';
import { create } from 'zustand';
import { useBuzzebeesAppStore } from './buzzebeess-app.store';
import { useLocaleStore } from './locale.store';

export interface CategoriesConfig {
  defaultMenuConfig?: string;
}

export type CategoriesState = {
  data: Category[];
  isLoading: boolean;
  error: ErrorResponse | null;
  config: CategoriesConfig;
};

export type CategoriesActions = {
  fetchData: () => Promise<ServiceResponse<Category[]>>;
  clear: () => void;
  updateConfig: (config: Partial<CategoriesConfig>) => void;
};

export type CategoriesStore = CategoriesState & CategoriesActions;

export const createCategoriesStore = (initialConfig: CategoriesConfig) => {
  return create<CategoriesStore>((set, get) => {
    return {
      data: [],
      isLoading: false,
      error: null,
      config: initialConfig,

      updateConfig: (newConfig: Partial<CategoriesConfig>) => {
        set((state) => ({
          config: { ...state.config, ...newConfig },
        }));
      },

      fetchData: async () => {
        const { config } = get();
        const bzbsService = useBuzzebeesAppStore.getState().bzbsService;

        if (!bzbsService || !config.defaultMenuConfig) {
          return { type: 'client-error', message: 'Service not configured or missing config' };
        }

        set({ isLoading: true, error: null });
        const response = await bzbsService.categoryApi.categories({
          config: config.defaultMenuConfig,
          byConfig: true,
          options: {
            device_locale: useLocaleStore.getState().localeId,
          },
        });
        set({ isLoading: false, error: null });

        if (response.type === 'success') {
          set({ data: response.model });
        } else {
          set({ error: response });
        }

        return response;
      },

      clear: () => {
        set({
          data: [],
          isLoading: false,
          error: null,
        });
      },
    };
  });
};
